export default __webpack_public_path__ + "static/media/arrowPrev.64a9c76f.svg";